module.exports = __webpack_public_path__ + "static/media/smartPayIcon.55836b8c.svg";